module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-1"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFENDING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTERIES")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v("  R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EBELLION")])]), _vm._v(" "), _c('p', {
    staticClass: "title1"
  }, [_vm._v("Confederate Naval Operations ")]), _vm._v(" "), _c('p', {
    staticClass: "title1"
  }, [_vm._v("in the Mississippi River Valley, 1861-1865")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_vm._v("Neil P. Chatelain")]), _vm._v(" "), _c('div', {
    staticClass: "img_container_"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Savas Beatie")])]), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("California")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-219eafbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/001_Title.vue
// module id = 60
// module chunks = 0